import { render, staticRenderFns } from "./sociales.vue?vue&type=template&id=705b4dfb&scoped=true&"
import script from "./sociales.vue?vue&type=script&lang=ts&"
export * from "./sociales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b4dfb",
  null
  
)

export default component.exports